import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./../../css/products.scss";

import insuranceonlinestore11x from "./../../images/insuranceonlinestore/insurance-online-store-1-1x.png";
import insuranceonlinestore12x from "./../../images/insuranceonlinestore/insurance-online-store-1-2x.png";
import insuranceonlinestore21x from "./../../images/insuranceonlinestore/insurance-online-store-2-1x.png";
import insuranceonlinestore22x from "./../../images/insuranceonlinestore/insurance-online-store-2-2x.png";
import insuranceonlinestore31x from "./../../images/insuranceonlinestore/insurance-online-store-3-1x.png";
import insuranceonlinestore32x from "./../../images/insuranceonlinestore/insurance-online-store-3-2x.png";
import insuranceonlinestore41x from "./../../images/insuranceonlinestore/insurance-online-store-4-1x.png";
import insuranceonlinestore42x from "./../../images/insuranceonlinestore/insurance-online-store-4-2x.png";
import insuranceonlinestore51x from "./../../images/insuranceonlinestore/insurance-online-store-5-1x.png";
import insuranceonlinestore52x from "./../../images/insuranceonlinestore/insurance-online-store-5-2x.png";

import imgPineapple1 from "./../../img/imgPineapple1.svg";

function Insuranceonlinestore(props) {
	
	const [insuranceonlinestore1WD, setInsuranceonlinestore1WD] = useState('');
	const [insuranceonlinestore2WD, setInsuranceonlinestore2WD] = useState('');
	const [insuranceonlinestore3WD, setInsuranceonlinestore3WD] = useState('');
	const [insuranceonlinestore4WD, setInsuranceonlinestore4WD] = useState('');
	const [insuranceonlinestore5WD, setInsuranceonlinestore5WD] = useState('');
	
   useEffect(() => {
	  if( props.wd < 1200 ){
		  setInsuranceonlinestore1WD(insuranceonlinestore11x);
		  setInsuranceonlinestore2WD(insuranceonlinestore21x);
		  setInsuranceonlinestore3WD(insuranceonlinestore31x);
		  setInsuranceonlinestore4WD(insuranceonlinestore41x);
		  setInsuranceonlinestore5WD(insuranceonlinestore51x);
	  } else if( props.wd >= 1200 ){
		  setInsuranceonlinestore1WD(insuranceonlinestore12x);
		  setInsuranceonlinestore2WD(insuranceonlinestore22x);
		  setInsuranceonlinestore3WD(insuranceonlinestore32x);
		  setInsuranceonlinestore4WD(insuranceonlinestore42x);
		  setInsuranceonlinestore5WD(insuranceonlinestore52x);
	  }
   },[props.wd]);
  
  return (
  
	<div>
        <Container>
          <div className="wrapBG">
            <Row className="wrapRowProducts1">
              <Col xl="6" lg="6" md="12" sm="12">
                <h1 className="h1insuranceApiPlatform h2insuranceApiPlatform1">
                  <span>Інтернет-магазин</span><br/>страхових послуг
                </h1>
                <p className="pProducts width80">
                  Забезпечте швидкий вихід на ринок нових онлайн-страхових продуктів. Надайте клієнтам винятковий онлайн-досвід.
                </p>
                <a href="/ua/contact" className="btn buttonOne aProduct">
                  Зв'язатися
                </a>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img src={insuranceonlinestore1WD} alt="" className="imgProduvts1" />
              </Col>
            </Row>
            <Row className="wrapRowProducts2">
              <Col xl="6" lg="6" md="12" sm="12" className="imgProduvts2top">
                <img src={insuranceonlinestore2WD} alt="" className="imgProduvts2" />
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <h2 className="h2Products">ПОВНІСТЮ ОНЛАЙН ПРОЦЕС ПРОДАЖУ</h2>
                <p className="pProducts">
                  Надайте своїм клієнтам наступні можливості:
                  <br />- Онлайн розрахунок премії.
                  <br />- Легкий вибір відповідного покриття та введення даних.
                  <br />- Онлайн підписання договору та обробка платежів.
                </p>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12" className="imgProduvts2bottom">
                <img src={insuranceonlinestore2WD} alt="" className="imgProduvts2" />
              </Col>
            </Row>
            <Row className="wrapRowProducts3">
              <Col xl="6" lg="6" md="12" sm="12">
                <h2 className="h2Products">
                  ПРОПОНУЙТЕ ПОВНИЙ СПЕКТР СТРАХОВИХ ПРОДУКТІВ ОНЛАЙН
                </h2>
                <p className="pProducts">
                  - Автострахування
                  <br />- Туристичне страхування
                  <br />- Страхування майна
                </p>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img src={insuranceonlinestore3WD} alt="" className="imgProduvts3" />
              </Col>
            </Row>
            <Row className="wrapRowProducts4">
              <Col xl="6" lg="6" md="12" sm="12" className="imgProduvts4top">
                <img src={insuranceonlinestore4WD} alt="" className="imgProduvts4" />
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <h2 className="h2Products">
                  НАЛАШТУЙТЕ БІЗНЕС-ПРОЦЕСИ ДЛЯ ПІДВИЩЕННЯ ОНЛАЙН ПРОДАЖІВ
                </h2>
                <p className="pProducts">
                  - Надайте легкий доступ до необхідних даних через панель управління продажами.
                  <br />- Використовуйте автоматизовану генерацію лідів з даними клієнтів, які не завершили покупку.
                  <br />- Впроваджуйте функціонал для збільшення продажів.
                </p>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12" className="imgProduvts4bottom">
                <img src={insuranceonlinestore4WD} alt="" className="imgProduvts4" />
              </Col>
            </Row>
            <Row className="wrapRowProducts5">
              <Col xl="6" lg="6" md="12" sm="12">
                <h2 className="h2Products">Отримайте можливість:</h2>
                <p className="pProducts">
                  - Налаштовувати процес продажів відповідно до ваших унікальних потреб.
                  <br />- Легко керуйте та налаштовуйте правила розрахунку тарифів.
                  <br />- Налаштовуйте бізнес-правила та друк договорів страхування відповідно до ваших вимог.
                </p>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img src={insuranceonlinestore5WD} alt="" className="imgProduvts5" />
              </Col>
            </Row>
            <Row className="wrapRowProducts6">
              <Col xl="6" lg="6" md="12" sm="12">
                <img
                  src={imgPineapple1}
                  alt=""
                  className="imgPineappleProduct"
                />
                <h2 className="h2Products">ХОЧЕТЕ ДІЗНАТИСЬ БІЛЬШЕ?</h2>
                <p className="pProducts">
                  Надайте свої бізнес-вимоги і ми розробимо ідеальне рішення, що відповідає вашим потребам.
                </p>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <a href="/ua/contact" className="btn buttonOne buttonProduct">Зв'язатися</a>
              </Col>
            </Row>
          </div>
        </Container>
	</div>
  
  );
}

export default Insuranceonlinestore;
